/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flag } from "./svg";
import classNames from "classnames";
import { useLoadReward } from "hooks";
import { useStreakVariant } from "../../hooks";
import { StreakDay as Streak } from "interfaces";
import { useImagePath } from "hooks/useImagePath";
import { dailyGiftAssets } from "assets/cdn";
import { Day, Image, Number, Banner, StarBurst, BannerText } from "./styles";
import { loadVariantAsset, STREAK_DAY_COLORS } from "./helper";
import useRewardsById from "hooks/useRewardsById";

interface StreakDayProps {
	streakDay: Streak;
	lastItem?: boolean;
}

export const StreakDay: React.FC<StreakDayProps> = ({
	streakDay,
	lastItem = false
}) => {
	const { loadReward } = useLoadReward();
	const { getImage } = useImagePath("cdn");
	const { rewardId, dayIndex } = streakDay;
	const { imageUrl, numberOfItems } = loadReward(lastItem ? "" : rewardId);
	const { variant, isAvailable, isLocked } = useStreakVariant(streakDay);
	const Asset = loadVariantAsset[variant];
	const lastItemClassName = classNames(lastItem && "last-item");
	const rewards = useRewardsById(rewardId);

	return (
		<Day
			className={lastItemClassName}
			style={{
				border: isAvailable ? `3px solid ${STREAK_DAY_COLORS[variant]}` : 0
			}}
		>
			<Banner className={lastItemClassName}>
				<BannerText className={classNames(variant)}>
					Day 0{dayIndex + 1}
				</BannerText>
				<Flag color={STREAK_DAY_COLORS[variant]} />
			</Banner>
			{!streakDay.collectedDate && (
				<div
					style={{
						position: "relative",
						width: "100%",
						display: "flex",
						justifyContent: "center"
					}}
				>
					<Image
						className={classNames(variant)}
						lastItem={lastItem}
						src={rewards[0]?.imageUrl || rewards[0]?.overrideImageUrl}
					/>
					{numberOfItems && (
						<Number
							className={classNames(variant)}
							style={{
								position: "absolute",
								bottom: -12,
								right: rewards?.[0]?.id !== "coin" ? -7 : 3,
								minWidth: "41%"
							}}
						>
							{numberOfItems?.toLocaleString("en-US")}
						</Number>
					)}
				</div>
			)}

			{lastItem && (
				<StarBurst src={getImage(dailyGiftAssets.streakDay.starBurst)} />
			)}
			{Asset && (
				<Asset
					src={getImage(
						isLocked
							? dailyGiftAssets.streakDay.locked
							: dailyGiftAssets.streakDay.check
					)}
				/>
			)}
		</Day>
	);
};
